<template>
  <div class="reserve">
    <div class="reserve-form">
      <van-form @submit="search">
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="searchForm.dateString"
          right-icon="arrow"
          label="最近时间"
          placeholder="点击选择最近时间"
          @click="dateShow = true"
        />
        <van-popup
          v-model="dateShow"
          position="bottom"
        >
          <van-calendar
            v-model="searchForm.date"
            :max-range="30"
            :min-date="new Date('2010-12-21')"
            :default-date="searchForm.date"
            :allow-same-day="true"
            @confirm="onDateConfirm"
            type="range"
          />
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="searchForm.complaint_levelString"
          right-icon="arrow"
          label="投诉级别"
          placeholder="点击选择类别"
          @click="showTypePicker = true"
        />
        <van-popup
          v-model="showTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="complaintLevelList"
            @confirm="onLevelConfirm"
            @cancel="showTypePicker = false"
          />
        </van-popup>
        <div style="margin: 16px;">
          <el-button
            type="primary"
            size="small"
            round
            @click="search"
            :loading="loading"
          >搜索</el-button>
        </div>

      </van-form>
      <div class="reserve-title">
        本次搜索投诉量：{{ complaintInfo.total_record_count }}； <br />
        一般投诉：{{ complaintInfo.yiban_record_count }}；跨部门投诉：{{ complaintInfo.kuabumen_record_count }}；重大投诉：{{ complaintInfo.zhongda_record_count }}；
      </div>
    </div>
    <div class="reserve-table">
      <el-table
        :data="tableData"
        height="100%"
        border
        style="width: 100%"
        size="small"
        row-key="appointmentNo"
        @row-click="rowClick"
      >
        <el-table-column
          prop="customer_name"
          label="投诉人"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="complaint_level"
          label="投诉级别"
          width="100px"
        >
          <template slot-scope="scope">
            {{  allEnum.ComplaintLevel && allEnum.ComplaintLevel[scope.row.complaint_level] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="complaint_target"
          label="投诉对象"
        >
        </el-table-column>
        <el-table-column
          prop="ageDesc"
          label="进度"
        >
          <template slot-scope="scope">
            {{ scope.row.is_archive === 1 ? '归档' : '处理中' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="deal_time"
          label="处理时长"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import getUserInfo from "@/models/userInfo";
import { Message } from "element-ui";
import complaintService from "@/apis/complaint/index.js";

export default {
  data() {
    return {
      allEnum: {},
      complaintLevelList: [],
      complaintInfo: {},
      dateShow: false,
      showTypePicker: false,
      showDoctorPicker: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 86400000 < Date.now();
        },
      },
      searchForm: {
        complaint_level: "",
        complaint_levelString: "全部",
        date: [
          new Date(moment().subtract(7, "days").format("YYYY-MM-DD")),
          new Date(moment().add(1, "days").format("YYYY-MM-DD")),
        ],
      },
      tableData: [],
      loading: false,
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        this.searchForm.dateString = `${moment(newVal.date[0]).format(
          "YYYY-MM-DD"
        )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    this.init();
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getTableList();
    this.getComplaintAllEnum();
  },
  methods: {
    rowClick(row) {
      this.$router.push({
        name: "WorkOrderDetail",
        query: {
          type: "complaint",
          id: row.ref_work_id,
        },
      });
    },
    getComplaintAllEnum() {
      complaintService.getComplaintAllEnum().then((res) => {
        const { ComplaintLevel } = res;
        const complaintLevelList = [
          {
            value: "",
            text: "全部",
          },
        ];
        Object.keys(ComplaintLevel).forEach((key) => {
          complaintLevelList.push({
            value: key,
            lable: ComplaintLevel[key],
            text: ComplaintLevel[key],
          });
        });
        this.complaintLevelList = complaintLevelList;
        this.allEnum = res;
      });
    },
    onDateConfirm(date) {
      this.searchForm.date = date;
      this.dateShow = false;
    },
    onLevelConfirm(item) {
      const { searchForm } = this;
      searchForm.complaint_levelString = item.text;
      searchForm.complaint_level = item.value;
      this.showTypePicker = false;
    },
    init() {},
    search() {
      const { searchForm } = this;
      const date = searchForm.date;
      if (moment(date[1]).isAfter(moment(date[0]).add(1, "months"))) {
        Message({
          message: "最多查询时间范围为一个月",
          type: "warning",
        });
        return;
      }
      this.getTableList();
    },
    getTableList() {
      const { searchForm } = this;
      const params = {
        time_start: moment(searchForm.date[0]).format("YYYY-MM-DD"),
        time_end: moment(searchForm.date[1]).format("YYYY-MM-DD"),
        ...searchForm,
        page_index: 1,
        page_size: 999,
      };
      this.loading = true;
      complaintService
        .workList(params)
        .then((res) => {
          this.tableData = res.data;
          this.complaintInfo = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.reserve {
  height: 100%;
  overflow: hidden;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .el-button {
    width: 100%;
    background-color: #e7635e;
    border: none;
  }
  .reserve-title {
    margin-bottom: 10px;
    color: #e7635e;
    min-height: 40px;
  }
  .reserve-table {
    flex: 1;
    overflow: hidden;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
  .el-date-editor.el-input__inner {
    width: 220px;
  }
}
</style>